import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ShareWrapper } from './share-wrapper.component';
import { environment } from '../../../environments/environment';
import { AttendeesViewData } from 'globals/store/programs.data';
import { AttendeesViewComponent } from '../attendees/attendees-view.component';

@Component({
    selector: 'share-attendees',
    template: `
<attendees-view
  [loading]="loading"
  [unavailable]="unavailable"
  [eventTitle]="data?.eventTitle" 
  [programs]="data?.programs" 
  [brandingData]="data?.brandingData"
  [attendees]="data?.attendees"
  [readOnly]="true"
></attendees-view>
`,
    styleUrls: ['./share-logistics.scss'],
    standalone: true,
    imports: [AttendeesViewComponent]
})
export class ShareAttendeesComponent extends ShareWrapper<ShareAttendeesComponent> {
    publishCode:string;
    loading:boolean = true;
    unavailable: boolean = false;
    submitted:boolean;
    readonly api = `${environment.functionsURL}api/v1`; // NOTE this is pointing to api/v1 not api/app

    data: AttendeesViewData
    
    constructor(private route:ActivatedRoute) {
      super()
      document.title = "loading";
      this.route.params.subscribe(params=> {
        if(!params || !params.hasOwnProperty('publishCode')) {
          this.loading = false;
          this.unavailable = true
          document.title = "Unavailable";
        } else {
          this.publishCode = params.publishCode;
          const url = `${this.api}/load-attendees-view/${this.publishCode}`
          this.take1(this.http.get(url)).then((data: AttendeesViewData) => {
            console.log({ data })
            document.title = "Production View"
            this.loading = false
            this.data = data
          }, (error) => {
            console.log(error)
            this.loading = false;
            this.unavailable = true
            document.title = "Production View Unavailable";
          })
        } 
      })
    }
  
}

